import React from 'react';
import cn from 'classnames';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/fit';
import { translate } from '@fiverr-private/i18n-react';
import GamingIllustration from './GamingIllustration';
import classes from './index.module.scss';

const getHREF = () =>
    pathfinder(
        'search_gigs',
        {},
        {
            query: {
                query: 'gaming logo',
                source: 'drop_down_filters',
                ref_ctx_id: 'e32960dc1beec83af66986afc4aec61b',
                search_in: 'category',
                'search-autocomplete-original-term': 'gaming logo',
                sub_category: 49,
                utm_source: 'Gaming+logo+banner',
                utm_medium: 'Gaming+logo+banner',
                utm_campaign: 'Gaming+logo+banner',
                utm_id: 'Gaming+logo+banner',
            },
        }
    );

const GamingBanner = () => (
    <div className={classes.wrapper}>
        <div className={classes.leftColumn}>
            <h3 className={cn(classes.title, 'font-domaine')}>
                {translate('logo_maker_perseus.buyer.listing.gaming_banner.title')}
            </h3>
            <Button className={classes.cta} href={getHREF()} target="_blank">
                {translate('logo_maker_perseus.buyer.listing.gaming_banner.cta')}
            </Button>
        </div>
        <div className={classes.rightColumn}>
            <GamingIllustration />
        </div>
    </div>
);

export default GamingBanner;
